/* ---------------------------------------------------------------------
   Tabbed rails on a phone: swipe to the next tab, with dots to show where
   you are (The 4 thing routine, Fashion This Week, The Luxe Edit).

   Opt in with [data-vro-tab-swipe] on the section (sections/feed-rail.liquid
   and sections/fashion-week-rail.liquid set it when the phone layout is a
   wrapped grid — a scrolling rail already spends a sideways swipe on its
   own cards). Inside it the theme's Bootstrap tabs: .rail-tabs
   .rail-tab-btn buttons and a .tab-content of panes.

   - A mostly-horizontal swipe of 50px+ over the panes clicks the next /
     previous tab button, so Bootstrap's own switch runs (and the scripts
     listening for it — counts, sub-filters) exactly as for a tap, and the
     tab strip scrolls to keep that tab in view. Below 768px only.
   - One dot per tab under the panes, the open tab's dot filled; a dot is
     a button too. Phones only (assets/custom.css hides them from 768px).
   - It slides: while swiping, the open tab follows the finger (with some
     give at the first and last tab); let go past the threshold and it
     slides off that side and the next tab slides in from the other.
     Changing tab any other way (tapping a tab or a dot) slides the new
     tab in from the matching side. Bootstrap's own 150ms fade is taken
     off these panes — it blanked the area between the two — and nothing
     moves for prefers-reduced-motion.
--------------------------------------------------------------------- */
(function () {
  'use strict';
  if (window.VroTabSwipe) return;
  window.VroTabSwipe = true;

  var PHONE = 768;

  function scrollsSideways(el, stop) {
    for (; el && el !== stop; el = el.parentElement) {
      var ox = getComputedStyle(el).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 1) return true;
    }
    return false;
  }

  function keepInView(btn) {
    var strip = btn.closest('.rail-tabs');
    if (!strip || strip.scrollWidth <= strip.clientWidth) return;
    var left = btn.getBoundingClientRect().left - strip.getBoundingClientRect().left + strip.scrollLeft;
    strip.scrollTo({ left: left - (strip.clientWidth - btn.offsetWidth) / 2, behavior: 'smooth' });
  }

  function init(root) {
    if (root.hasAttribute('data-vro-tab-swipe-ready')) return;
    var panes = root.querySelector('.tab-content');
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.rail-tabs .rail-tab-btn'));
    if (!panes || tabs.length < 2) return;
    root.setAttribute('data-vro-tab-swipe-ready', '');

    function current() {
      for (var i = 0; i < tabs.length; i++) if (tabs[i].classList.contains('active')) return i;
      return 0;
    }
    function go(i) {
      var btn = tabs[i];
      if (!btn || i === current()) return;
      btn.click();
      keepInView(btn);
    }

    /* ---- dots ---- */
    var dots = document.createElement('div');
    dots.className = 'vro-tab-dots';
    dots.setAttribute('role', 'group');
    dots.setAttribute('aria-label', 'Tabs');
    tabs.forEach(function (btn, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'vro-tab-dot';
      dot.setAttribute('aria-label', (btn.textContent || '').trim() || 'Tab ' + (i + 1));
      dot.addEventListener('click', function () { go(i); });
      dots.appendChild(dot);
    });
    panes.parentNode.insertBefore(dots, panes.nextSibling);
    function paint() {
      var at = current();
      Array.prototype.forEach.call(dots.children, function (d, i) {
        d.classList.toggle('is-active', i === at);
        d.setAttribute('aria-current', i === at ? 'true' : 'false');
      });
    }
    tabs.forEach(function (btn) { btn.addEventListener('shown.bs.tab', paint); });
    paint();

    /* ---- slide ---- */
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE = 'cubic-bezier(.2,.8,.2,1)';
    Array.prototype.forEach.call(panes.querySelectorAll('.tab-pane.fade'), function (p) {
      p.classList.remove('fade');
      p.classList.add('show');
    });
    function activePane() { return panes.querySelector(':scope > .tab-pane.active'); }
    function slide(el, from, to, ms, done) {
      if (!el || still || !el.animate) { if (el) el.style.transform = ''; if (done) done(); return; }
      var a = el.animate([
        { transform: 'translateX(' + from + 'px)', opacity: from === 0 ? 1 : 0.4 },
        { transform: 'translateX(' + to + 'px)', opacity: to === 0 ? 1 : 0.4 }
      ], { duration: ms, easing: EASE });
      el.style.transform = to ? 'translateX(' + to + 'px)' : '';
      a.onfinish = function () { if (done) done(); };
    }
    /* Which way the incoming tab enters: set by a swipe for the tab it
       opens; otherwise worked out from the tab it replaced. */
    var entering = 0;
    tabs.forEach(function (btn, i) {
      btn.addEventListener('shown.bs.tab', function (e) {
        var dir = entering;
        entering = 0;
        if (!dir) {
          var was = tabs.indexOf(e.relatedTarget);
          dir = was === -1 ? 0 : (i > was ? 1 : -1);
        }
        var pane = activePane();
        if (dir && pane) slide(pane, dir * panes.clientWidth * 0.6, 0, 280);
      });
    });

    /* ---- swipe ---- */
    var x0 = null, y0 = 0, lock = '', dx = 0, dragged = null;
    panes.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= PHONE || e.touches.length !== 1 || scrollsSideways(e.target, panes)) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      lock = ''; dx = 0; dragged = null;
    }, { passive: true });
    panes.addEventListener('touchmove', function (e) {
      if (x0 === null || lock === 'y') return;
      var mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
      if (!lock) {
        if (Math.abs(mx) < 10 && Math.abs(my) < 10) return;
        lock = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
        if (lock === 'y') return;
      }
      dx = mx;
      var at = current();
      /* Some give, not a free slide, past the first or last tab. */
      if ((dx > 0 && at === 0) || (dx < 0 && at === tabs.length - 1)) dx = dx * 0.25;
      if (still) return;
      dragged = activePane();
      if (dragged) dragged.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: true });
    function settle(e) {
      if (x0 === null) return;
      var end = e.changedTouches && e.changedTouches[0];
      var mx = end ? end.clientX - x0 : dx, my = end ? end.clientY - y0 : 0;
      x0 = null;
      var pane = dragged;
      dragged = null;
      var at = current();
      var next = at + (mx < 0 ? 1 : -1);
      var go_on = lock !== 'y' && e.type === 'touchend' && Math.abs(mx) >= 50 &&
        Math.abs(mx) >= Math.abs(my) * 1.5 && next >= 0 && next < tabs.length;
      if (!go_on) {
        if (pane && dx) slide(pane, dx, 0, 200);
        return;
      }
      var dir = mx < 0 ? 1 : -1;
      slide(pane || activePane(), pane ? dx : 0, -dir * panes.clientWidth, 160, function () {
        var old = pane || activePane();
        entering = dir;
        go(next);
        if (old) old.style.transform = '';
      });
    }
    panes.addEventListener('touchend', settle, { passive: true });
    panes.addEventListener('touchcancel', settle, { passive: true });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vro-tab-swipe]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  /* Sections re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', initAll);
})();
